import { Route, Routes, Navigate } from 'react-router-dom';
import HubPage from './hub/HubPage';
import CryptogramGame from './games/cryptogram/CryptogramGame';
import WordCircleGame from './games/wordCircle/WordCircleGame';
import WordSearchGame from './games/wordSearch/WordSearchGame';
import WordLadderGame from './games/wordLadder/WordLadderGame';
import HashtagGame from './games/hashtag/HashtagGame';
import WordBloomGame from './games/wordBloom/WordBloomGame';
import CodeWordGame from './games/codeWord/CodeWordGame';
import RootwordsGame from './games/rootwords/RootwordsGame';
import WordDominoesGame from './games/wordDominoes/WordDominoesGame';
import EmojiAnagramGame from './games/emojiAnagram/EmojiAnagramGame';
import GroupThinkGame from './games/groupThink/GroupThinkGame';
import WordChainGame from './games/wordChain/WordChainGame';
import NumberCrunchGame from './games/numberCrunch/NumberCrunchGame';
import TopAnswerGame from './games/topAnswer/TopAnswerGame';
import LongshotGame from './games/longshot/LongshotGame';
import GauntletPage from './gauntlet/GauntletPage';
import { BlogIndexPage, BlogPostPage } from './blog/BlogPages';
import PrivacyPage from './legal/PrivacyPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HubPage />} />
      <Route path="/play/cryptogram" element={<CryptogramGame />} />
      <Route path="/play/wordCircle" element={<WordCircleGame />} />
      <Route path="/play/wordSearch" element={<WordSearchGame />} />
      <Route path="/play/wordLadder" element={<WordLadderGame />} />
      <Route path="/play/hashtag" element={<HashtagGame />} />
      <Route path="/play/wordBloom" element={<WordBloomGame />} />
      <Route path="/play/codeWord" element={<CodeWordGame />} />
      <Route path="/play/rootwords" element={<RootwordsGame />} />
      <Route path="/play/wordDominoes" element={<WordDominoesGame />} />
      <Route path="/play/emojiAnagram" element={<EmojiAnagramGame />} />
      <Route path="/play/groupThink" element={<GroupThinkGame />} />
      <Route path="/play/wordChain" element={<WordChainGame />} />
      <Route path="/play/numberCrunch" element={<NumberCrunchGame />} />
      <Route path="/play/topAnswer" element={<TopAnswerGame />} />
      <Route path="/play/longshot" element={<LongshotGame />} />
      <Route path="/gauntlet" element={<GauntletPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/blog" element={<BlogIndexPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
